import { foundationButtonStyles } from '@genesislcap/foundation-ui';
import { neutralFillActive, neutralFillHover, neutralFillRest, neutralForegroundRest, neutralStrokeActive, neutralStrokeRest, } from '@microsoft/fast-components';
import { css } from '@microsoft/fast-element';
import { PrimaryRapidColorHEX, SecondaryRapidColorHEX } from '../_common';
import { primaryBlueWebRGBA, primaryPurpleWebRGBA, secondaryTealWebRGBA, whiteWebRGBA, secondaryOrangeWebRGBA, } from '../_config/styles/colors';
import { appearanceBehavior } from '../utils';
const stockStateOpacity = 0.3;
const activeStateOpacity = 0.1;
const activeStateFontOpacity = 0.5;
const zeroPrimaryBlueStyles = css `
  :host([appearance='primary-blue']) {
    background: ${primaryBlueWebRGBA(stockStateOpacity)};
    border: 1px solid ${PrimaryRapidColorHEX.blue};
  }

  :host([appearance='primary-blue']:hover) {
    background: ${PrimaryRapidColorHEX.blue};
  }

  :host([appearance='primary-blue']:active) {
    background: ${primaryBlueWebRGBA(activeStateOpacity)};
    border: 1px solid ${primaryBlueWebRGBA(stockStateOpacity)};
    color: ${whiteWebRGBA(activeStateFontOpacity)};
  }
`;
const zeroPrimaryPurpleStyles = css `
  :host([appearance='primary-purple']) {
    background: ${primaryPurpleWebRGBA(stockStateOpacity)};
    border: 1px solid ${PrimaryRapidColorHEX.purple};
  }

  :host([appearance='primary-purple']:hover) {
    background: ${PrimaryRapidColorHEX.purple};
  }

  :host([appearance='primary-purple']:active) {
    background: ${primaryPurpleWebRGBA(activeStateOpacity)};
    border: 1px solid ${primaryPurpleWebRGBA(stockStateOpacity)};
    color: ${whiteWebRGBA(activeStateFontOpacity)};
  }
`;
const zeroPrimaryGradientStyles = css `
  :host {
    --primary-gradient-angle: -113.5deg;
  }

  :host([appearance='primary-gradient']) {
    background-image: linear-gradient(
      var(--primary-gradient-angle),
      ${PrimaryRapidColorHEX.blue},
      ${PrimaryRapidColorHEX.purple}
    );
    background-origin: border-box;
    border: solid 1px transparent;
    box-shadow: 2px 1000px 1px rgb(0 0 0 / 50%) inset;
  }

  :host([appearance='primary-gradient']:hover) {
    background-image: linear-gradient(
      var(--primary-gradient-angle),
      ${PrimaryRapidColorHEX.blue},
      ${PrimaryRapidColorHEX.purple}
    );
    background-origin: border-box;
    border: solid 1px transparent;
    box-shadow: 2px 1000px 1px transparent inset;
  }

  :host([appearance='primary-gradient']:active) {
    background-image: linear-gradient(
      var(--primary-gradient-angle),
      ${primaryBlueWebRGBA(stockStateOpacity)},
      ${primaryPurpleWebRGBA(stockStateOpacity)}
    );
    background-origin: border-box;
    border: solid 1px transparent;
    box-shadow: 2px 1000px 1px rgb(0 0 0 / 30%) inset;
    color: ${whiteWebRGBA(activeStateFontOpacity)};
  }
`;
const zeroSecondaryOrangeStyles = css `
  :host([appearance='secondary-orange']) {
    background: ${secondaryOrangeWebRGBA(stockStateOpacity)};
    border: 1px solid ${SecondaryRapidColorHEX.orange};
  }

  :host([appearance='secondary-orange']:hover) {
    background: ${SecondaryRapidColorHEX.orange};
  }

  :host([appearance='secondary-orange']:active) {
    background: ${secondaryOrangeWebRGBA(activeStateOpacity)};
    border: 1px solid ${secondaryOrangeWebRGBA(stockStateOpacity)};
    color: ${whiteWebRGBA(activeStateFontOpacity)};
  }
`;
const zeroSecondaryTealStyles = css `
  :host([appearance='secondary-teal']) {
    background: ${secondaryTealWebRGBA(stockStateOpacity)};
    border: 1px solid ${SecondaryRapidColorHEX.teal};
  }

  :host([appearance='secondary-teal']:hover) {
    background: ${SecondaryRapidColorHEX.teal};
  }

  :host([appearance='secondary-teal']:active) {
    background: ${secondaryTealWebRGBA(activeStateOpacity)};
    border: 1px solid ${secondaryTealWebRGBA(stockStateOpacity)};
    color: ${whiteWebRGBA(activeStateFontOpacity)};
  }
`;
const zeroNeutralGreyStyles = css `
  :host([appearance='neutral-grey']) {
    background: ${neutralFillRest};
    border: 1px solid ${neutralStrokeRest};
  }

  :host([appearance='neutral-grey']:hover) {
    background: ${neutralFillHover};
  }

  :host([appearance='neutral-grey']:active) {
    background: ${neutralFillActive};
    border: 1px solid ${neutralStrokeActive};
    color: ${neutralForegroundRest};
  }
`;
const zeroOutlinePrimaryGradientStyles = css `
  :host {
    --primary-gradient-angle: -113.5deg;
  }

  :host([appearance='outline-primary-gradient']) {
    background:
      linear-gradient(
          var(--primary-gradient-angle),
          ${PrimaryRapidColorHEX.blue} 0%,
          ${PrimaryRapidColorHEX.purple} 100%
        )
        top/100% 1px,
      linear-gradient(
          var(--primary-gradient-angle),
          ${PrimaryRapidColorHEX.blue} 0%,
          ${PrimaryRapidColorHEX.purple} 100%
        )
        bottom/100% 1px;
    background-origin: border-box;
    background-repeat: no-repeat;
    border: 1px solid transparent;
    border-right-color: ${PrimaryRapidColorHEX.blue};
    border-left-color: ${PrimaryRapidColorHEX.purple};
  }

  :host([appearance='outline-primary-gradient']:hover) {
    background: unset;
    background-repeat: unset;
    background-image: linear-gradient(
      var(--primary-gradient-angle),
      ${PrimaryRapidColorHEX.blue},
      ${PrimaryRapidColorHEX.purple}
    );
    background-origin: border-box;
    box-shadow: 1px 1000px 1px rgb(0 0 0 / 50%) inset;
  }

  :host([appearance='outline-primary-gradient']:active) {
    box-shadow: unset;
    background:
      linear-gradient(
          var(--primary-gradient-angle),
          ${primaryBlueWebRGBA(stockStateOpacity)} 0%,
          ${primaryPurpleWebRGBA(stockStateOpacity)} 100%
        )
        top/100% 1px,
      linear-gradient(
          var(--primary-gradient-angle),
          ${primaryBlueWebRGBA(stockStateOpacity)} 0%,
          ${primaryPurpleWebRGBA(stockStateOpacity)} 100%
        )
        bottom/100% 1px;
    background-origin: border-box;
    background-repeat: no-repeat;
    border: 1px solid transparent;
    border-right-color: ${primaryBlueWebRGBA(stockStateOpacity)};
    border-left-color: ${primaryPurpleWebRGBA(stockStateOpacity)};
    color: ${whiteWebRGBA(activeStateFontOpacity)};
  }
`;
const zeroOutlineSecondaryOrangeStyles = css `
  :host([appearance='outline-secondary-orange']) {
    background: transparent;
    border: 1px solid ${SecondaryRapidColorHEX.orange};
  }

  :host([appearance='outline-secondary-orange']:hover) {
    background: ${secondaryOrangeWebRGBA(stockStateOpacity)};
  }

  :host([appearance='outline-secondary-orange']:active) {
    background: transparent;
    border: 1px solid ${secondaryOrangeWebRGBA(stockStateOpacity)};
    color: ${whiteWebRGBA(activeStateFontOpacity)};
  }
`;
const zeroOutlineSecondaryTealStyles = css `
  :host([appearance='outline-secondary-teal']) {
    background: transparent;
    border: 1px solid ${SecondaryRapidColorHEX.teal};
  }

  :host([appearance='outline-secondary-teal']:hover) {
    background: ${secondaryTealWebRGBA(stockStateOpacity)};
  }

  :host([appearance='outline-secondary-teal']:active) {
    background: transparent;
    border: 1px solid ${secondaryTealWebRGBA(stockStateOpacity)};
    color: ${whiteWebRGBA(activeStateFontOpacity)};
  }
`;
const baseStyles = (context, definition) => css `
  :host {
    margin: 5px;
  }
`;
export const zeroButtonStyles = (context, definition) => css `
    ${foundationButtonStyles(context, definition)}
    ${baseStyles(context, definition)}
  `.withBehaviors(appearanceBehavior('primary-blue', zeroPrimaryBlueStyles), appearanceBehavior('primary-purple', zeroPrimaryPurpleStyles), appearanceBehavior('primary-gradient', zeroPrimaryGradientStyles), appearanceBehavior('secondary-orange', zeroSecondaryOrangeStyles), appearanceBehavior('secondary-teal', zeroSecondaryTealStyles), appearanceBehavior('neutral-grey', zeroNeutralGreyStyles), appearanceBehavior('outline-primary-gradient', zeroOutlinePrimaryGradientStyles), appearanceBehavior('outline-secondary-orange', zeroOutlineSecondaryOrangeStyles), appearanceBehavior('outline-secondary-teal', zeroOutlineSecondaryTealStyles));
